<script setup lang="ts">
import UploadPanel from '../components/UploadPanel/UploadPanel.vue'
import { useGameStore } from '../stores/game'

const store = useGameStore()
</script>

<template>
  <div class="page-stack">
    <section class="page-heading">
      <div>
        <p class="eyebrow">任务与依赖</p>
        <h1>任务链</h1>
        <p>统一展示 v4 语义层中的前置任务、解锁关系、据点目标和逐项完成度。</p>
      </div>
    </section>

    <UploadPanel v-if="!store.loaded" />

    <section class="content-panel">
      <p v-if="!store.loaded" class="empty-state">导入 v4 单文件后显示任务链。</p>
      <p v-else-if="store.quests.length === 0" class="empty-state">存档中没有活跃任务。</p>
      <div v-else class="quest-grid">
        <article
          v-for="quest in store.quests"
          :key="quest.id"
          class="quest-card"
          :class="{ ready: quest.objectivesMet }"
        >
          <header>
            <div>
              <span>#{{ quest.id }} · {{ quest.storyName || '未分组' }}</span>
              <h2>{{ quest.title }}</h2>
              <small v-if="quest.englishTitle">{{ quest.englishTitle }}</small>
            </div>
            <b>{{ quest.objectivesMet ? '可交付' : '进行中' }}</b>
          </header>

          <ul class="objective-list">
            <li v-for="objective in quest.objectives" :key="objective.index">
              <span :class="{ done: objective.completed }"></span>
              <div>
                <strong>{{ objective.targetName }}</strong>
                <small>
                  {{ objective.current }}/{{ objective.required }}
                  <template v-if="objective.missing"> · 还差 {{ objective.missing }}</template>
                  <template v-if="objective.outpostName"> · {{ objective.outpostName }}</template>
                </small>
              </div>
            </li>
          </ul>

          <footer>
            <div>
              <span>前置</span>
              <small>
                {{ quest.requires.map((item) => `#${item.questId} ${item.name}`).join('、') || '无已映射前置' }}
              </small>
            </div>
            <div>
              <span>完成后</span>
              <small>
                {{ quest.unlocks.map((item) => `#${item.questId} ${item.name}`).join('、') || '无已映射解锁' }}
              </small>
            </div>
            <div>
              <span>交付</span>
              <small>{{ quest.giverName }} → {{ quest.receiverName }}</small>
            </div>
          </footer>
        </article>
      </div>
    </section>
  </div>
</template>
